// src/pages/TaxCorrectionPage.jsx

import React, { useState } from 'react';
import { Download } from 'lucide-react'; // Using lucide-react for icons

// It's best practice to store your API URL in an environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function TaxCorrectionPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // --- Logic for handling the export ---
  // In src/pages/TaxCorrectionPage.jsx

  const handleExport = async () => {
    setIsLoading(true);
    setError(null);
    
    // --- START: ADDED CODE ---
    const token = localStorage.getItem('token');

    if (!token) {
      setError('You are not logged in. Please log in to export data.');
      setIsLoading(false);
      return;
    }

    const headers = {
      'Authorization': `Bearer ${token}`
    };
    // --- END: ADDED CODE ---

    try {
      // Pass the headers to the fetch request
      const response = await fetch(`${API_BASE_URL}/reports/export-product-tax-data`, { headers });

      if (!response.ok) {
        // ... (rest of the error handling is the same)
        const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch the file.' }));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }
      
      // ... (rest of the file download logic is the same)
      const disposition = response.headers.get('content-disposition');
      let filename = 'product-tax-data.xlsx';
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error('Export failed:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // --- JSX for the page layout and button ---
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Tax Correction Tools</h1>
          <p className="mt-2 text-sm text-gray-700">
            Export all product data to identify and correct tax discrepancies.
          </p>
        </div>
      </div>

      <div className="mt-8 p-4 border border-dashed rounded-lg">
        <h2 className="text-lg font-medium text-gray-900">Export Current Product Data</h2>
        <p className="mt-1 text-sm text-gray-600">
          Download an Excel file containing every product and its current effective tax rate. Use this file to review your data before making corrections.
        </p>
        <div className="mt-4">
          <button
            onClick={handleExport}
            disabled={isLoading}
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Download className="w-4 h-4 mr-2" />
            {isLoading ? 'Exporting...' : 'Export Product Tax Data'}
          </button>
          {error && <p className="mt-2 text-sm text-red-600">Error: {error}</p>}
        </div>
      </div>

      {/* You can add the UI for viewing and correcting conflicts here in the future */}
    </div>
  );
}

export default TaxCorrectionPage;